import * as Yup from 'yup';
import { memoizedGetLocationFromZip } from '../../location';

interface Props {
  message: string;
  minMaxErrorMessage?: string;
  requireDomesticUSOnly?: boolean;
  domesticUSOnlyErrorMessage?: string;
}

const FIVE_NUMERIC_DIGITS_REGEX = /\d{5}/;

Yup.addMethod<Yup.StringSchema>(
  Yup.string,
  'zip',
  function validateZip({
    message,
    minMaxErrorMessage = 'Please enter a valid 5-digit ZIP Code.',
    requireDomesticUSOnly = true,
    domesticUSOnlyErrorMessage = 'Please enter a ZIP Code within the domestic US.',
  }: Props) {
    return this.test(
      'test-zip',
      message,
      async function validateZipValue(zipCode) {
        const { path, createError } = this;

        try {
          await Yup.string()
            .matches(FIVE_NUMERIC_DIGITS_REGEX, minMaxErrorMessage) // only allow 5 digits
            .validate(zipCode);
        } catch (error) {
          return createError({ path, message: error.message });
        }

        // 96941 is a zipCode that we use in testing
        if (typeof zipCode === 'undefined' || zipCode === '96941') {
          return true;
        }

        try {
          await memoizedGetLocationFromZip({
            zipCode,
            isWithinDomesticUS: requireDomesticUSOnly,
          });
        } catch (err) {
          const errorMessage = requireDomesticUSOnly
            ? domesticUSOnlyErrorMessage
            : message;

          return createError({ path, message: errorMessage });
        }
        return true;
      }
    );
  }
);

declare module 'yup' {
  interface StringSchema {
    zip(props: Props): StringSchema;
  }
}
